import React from 'react';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import Heading from '@legacy-vfuk/core-heading';
import Spacing, { SpacingProps } from '@legacy-vfuk/core-spacing';

export type HeaderContentProps = {
  kind?: 'header';
  __typename?: 'ContentfulSectionElementHeader';
  id?: string;
  name?: string;
  headerText: string;
  appearance?: 'primary' | 'secondary';
  inverse?: boolean;
  justify: 'left' | 'center' | 'right';
  level: 1 | 2 | 3 | 4 | 5;
  noMargin?: boolean;
  size?: 1 | 2 | 3 | 4 | 5;
  weight?: 1 | 2 | 3 | 4;
  className?: string;
};

export type HeaderProps = {
  __typename?: string;
  id?: string;
  spacingLevel?: SpacingProps['spacingLevel']
  content: HeaderContentProps;
};

const Header = (props: HeaderProps) => {
  const {
    content: {
      headerText,
      appearance,
      inverse,
      justify,
      level,
      noMargin,
      weight,
    },
    spacingLevel = { bottom: 4, top: 6 },
  } = props;

  return (
    <SimpleGrid
      columns={{
        sm: 1
      }}
    >
      <Spacing spacingLevel={spacingLevel}>
        <Heading
          text={headerText}
          appearance={appearance ? appearance : 'primary'}
          inverse={inverse}
          justify={justify || 'center'}
          level={level}
          noMargin={noMargin}
          weight={weight ? weight : 2}
        />
      </Spacing>
    </SimpleGrid>
  );
};

export default Header;
